import Endpoint from "../../services/api/endpoint";
import { IRemark } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IRemark>(Endpoint.MyRemarks, Endpoint.MyRemarksList);